import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initStats } from './lib/stats'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// anonymní statistika návštěvnosti bez cookies (5. 11. 2026)
initStats()
